import { api } from './api';
import type {
  AuditEntry,
  EventCatalogItem,
  SubscriptionCreate,
  SubscriptionDetail,
} from '@/types/notification';

export const notificationsApi = {
  catalog: () => api.get<EventCatalogItem[]>('/notifications/catalog'),
  list: () => api.get<SubscriptionDetail[]>('/notifications/subscriptions'),
  create: (payload: SubscriptionCreate) =>
    api.post<SubscriptionDetail>('/notifications/subscriptions', payload),
  delete: (id: string) =>
    api.delete<{ deleted: boolean }>(`/notifications/subscriptions/${id}`),
  test: (subscriptionId: string, eventId: string, message: string) =>
    api.post<{ event: unknown; dispatch_result: unknown }>(`/notifications/test`, {
      subscription_id: subscriptionId,
      event_id: eventId,
      sample_message: message,
    }),
};

export const auditApi = {
  list: (params: { limit?: number; resource_type?: string; actor_id?: string } = {}) => {
    const qs = new URLSearchParams();
    if (params.limit) qs.set('limit', String(params.limit));
    if (params.resource_type) qs.set('resource_type', params.resource_type);
    if (params.actor_id) qs.set('actor_id', params.actor_id);
    return api.get<AuditEntry[]>(`/audit?${qs}`);
  },
};
